"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = require("../../constants/Field");
var DataItem_1 = require("../common/base/DataItem");
var DataType_1 = require("../common/base/DataType");
var lodash_1 = require("lodash");
var Inhibit = /** @class */ (function () {
    function Inhibit() {
        this.init();
    }
    Inhibit.fromJson = function (json, isInstance, objectInstanceIds) {
        var inhibit = new Inhibit();
        var referenceValue = json[Field_1.FIELD.REFERENCEVALUE];
        var actualValue = json[Field_1.FIELD.ACTUALVALUE];
        if (referenceValue !== undefined) {
            var dataItem = DataItem_1.DataItem.fromJson(Field_1.FIELD.REFERENCEVALUE, referenceValue);
            dataItem.removeObjectId(isInstance, objectInstanceIds, false);
            inhibit.initReferenceValue(dataItem);
        }
        else {
            inhibit.initReferenceValue(new DataItem_1.DataItem(Field_1.FIELD.REFERENCEVALUE, DataType_1.DataType.string));
        }
        if (actualValue !== undefined) {
            var dataItem = DataItem_1.DataItem.fromJson(Field_1.FIELD.ACTUALVALUE, actualValue);
            dataItem.removeObjectId(isInstance, objectInstanceIds, false);
            inhibit.initActualValue(dataItem);
        }
        else {
            inhibit.initActualValue(new DataItem_1.DataItem(Field_1.FIELD.ACTUALVALUE, DataType_1.DataType.string));
        }
        return inhibit;
    };
    Inhibit.prototype.toJson = function (includeOnlyValueOrReference) {
        var json = Object.create(null);
        json = Object.assign(json, this.referenceToJson(includeOnlyValueOrReference), this.actualToJson(includeOnlyValueOrReference));
        return json;
    };
    Inhibit.prototype.referenceToJson = function (includeOnlyValueOrReference) {
        var json = Object.create(null);
        if (this.isEmptyOrUndefined(this.referenceValue)) {
            return json;
        }
        var refJson = this.referenceValue.toJson(includeOnlyValueOrReference);
        if (!refJson[Field_1.FIELD.VALUE]) {
            refJson[Field_1.FIELD.VALUE] = this.referenceValue.getDefaultItemValue();
        }
        json[Field_1.FIELD.REFERENCEVALUE] = refJson;
        return json;
    };
    Inhibit.prototype.actualToJson = function (includeOnlyValueOrReference) {
        var json = Object.create(null);
        if (this.isEmptyOrUndefined(this.actualValue)) {
            return json;
        }
        var actjson = this.actualValue.toJson(includeOnlyValueOrReference);
        if (!actjson[Field_1.FIELD.VALUE]) {
            actjson[Field_1.FIELD.VALUE] = this.actualValue.getDefaultItemValue();
        }
        json[Field_1.FIELD.ACTUALVALUE] = actjson;
        return json;
    };
    Inhibit.prototype.init = function () {
        this.referenceValue = new DataItem_1.DataItem(Field_1.FIELD.REFERENCEVALUE, DataType_1.DataType.string);
        this.actualValue = new DataItem_1.DataItem(Field_1.FIELD.ACTUALVALUE, DataType_1.DataType.string);
    };
    Inhibit.prototype.initReferenceValue = function (referenceValue) {
        this.referenceValue = referenceValue;
    };
    Inhibit.prototype.initActualValue = function (actualValue) {
        this.actualValue = actualValue;
    };
    Inhibit.prototype.isEmptyOrUndefined = function (dataItem) {
        if (dataItem.link === undefined &&
            dataItem.value === undefined) {
            return true;
        }
        else if (dataItem.link === undefined) {
            if (dataItem.value === '') {
                return true;
            }
            return false;
        }
        else if (lodash_1.isEmpty(dataItem.link)) {
            return true;
        }
        return false;
    };
    return Inhibit;
}());
exports.Inhibit = Inhibit;
//# sourceMappingURL=Inhibit.js.map